import React from 'react';
import { useState } from 'react';
import BurgerMenu from './BurgerMenu';
import "./NavBar.css";
import { Link } from 'react-router-dom';
import Logo from '../Images/WildLogoWhite.png';


const NavBar = () => {
    const [hamburgerOpen, setHamburgerOpen] = useState(false);

    const toggleHamburger = () => {
        setHamburgerOpen(!hamburgerOpen)
    }

    return (
        <nav>

            <ul className="navList">
                <Link to='/'>
                    <li className="items">HOME</li>
                </Link>
                <Link to='/players'>
                    <li className="items">PLAYERS</li>
                </Link>

                <img src={Logo} alt="wildLogo" className='wildLogo' />

                <Link to='/myPlayers'>
                    <li className="items">MY PLAYERS</li>
                </Link>
                <Link to='/myTeam'>
                    <li className="items">MY TEAM</li>
                </Link>
            </ul>
            <div className='burgerM' onClick={toggleHamburger}>
                <BurgerMenu isOpen={hamburgerOpen} />
            </div>
        </nav>
    );

}


export default NavBar;


